export type TaskProgressFilter = 'all' | 'not_started' | 'pending' | 'completed' | 'unfinished';
export type TaskProgressTotals = { total: number; notStarted: number; pending: number; completed: number };

export const taskProgressColumns = [
  { filter: 'not_started', key: 'notStarted', label: 'Not started', description: 'To-do tasks that have not started' },
  { filter: 'pending', key: 'pending', label: 'Pending', description: 'In progress, in review or blocked' },
  { filter: 'completed', key: 'completed', label: 'Completed', description: 'Tasks marked done' },
] as const;

export function matchesTaskProgress(status: string, filter: TaskProgressFilter) {
  if (filter === 'not_started') return status === 'todo';
  if (filter === 'pending') return ['doing', 'review', 'blocked'].includes(status);
  if (filter === 'completed') return status === 'done';
  if (filter === 'unfinished') return status !== 'done';
  return true;
}
